<script>
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";

  export let autoWidth;
  export let paymentsEnabled;
</script>

<FizzStyles>
  <table class="fizz-table-matrix" style={!autoWidth ? "width: 100%;" : ""}>
    <thead>
      <tr>
        <th>Permissions per role</th>
        <th class="align-center">Admin</th>
        <th class="align-center">Manager</th>
        <th class="align-center">Employee</th>
        {#if paymentsEnabled}<th class="align-center">Finance</th>{/if}
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><strong>Orders</strong></td>
        <td />
        <td />
        <td />
        {#if paymentsEnabled}<td />{/if}
      </tr>
      <tr>
        <td>Add to Cart</td>
        <td
          ><Icon
            type="CheckCircle"
            height="16"
            width="16"
            color="#36B37E"
            extraClassNames="fizz-margin-auto"
          /></td
        >
        <td
          ><Icon
            type="CheckCircle"
            height="16"
            width="16"
            color="#36B37E"
            extraClassNames="fizz-margin-auto"
          /></td
        >
        <td
          ><Icon
            type="CheckCircle"
            height="16"
            width="16"
            color="#36B37E"
            extraClassNames="fizz-margin-auto"
          /></td
        >
        {#if paymentsEnabled}
          <td
            ><Icon
              type="CheckCircle"
              height="16"
              width="16"
              color="#36B37E"
              extraClassNames="fizz-margin-auto"
            /></td
          >
        {/if}
      </tr>
      <tr>
        <td>Submit Orders</td>
        <td
          ><Icon
            type="CheckCircle"
            height="16"
            width="16"
            color="#36B37E"
            extraClassNames="fizz-margin-auto"
          /></td
        >
        <td
          ><Icon
            type="CheckCircle"
            height="16"
            width="16"
            color="#36B37E"
            extraClassNames="fizz-margin-auto"
          /></td
        >
        <td
          ><Icon
            type="CancelCircle"
            height="16"
            width="16"
            color="#E1434F"
            extraClassNames="fizz-margin-auto"
          /></td
        >
        {#if paymentsEnabled}
          <td
            ><Icon
              type="CancelCircle"
              height="16"
              width="16"
              color="#E1434F"
              extraClassNames="fizz-margin-auto"
            /></td
          >
        {/if}
      </tr>
      <tr>
        <td>Manage Employees</td>
        <td
          ><Icon
            type="CheckCircle"
            height="16"
            width="16"
            color="#36B37E"
            extraClassNames="fizz-margin-auto"
          /></td
        >
        <td
          ><Icon
            type="CancelCircle"
            height="16"
            width="16"
            color="#E1434F"
            extraClassNames="fizz-margin-auto"
          /></td
        >
        <td
          ><Icon
            type="CancelCircle"
            height="16"
            width="16"
            color="#E1434F"
            extraClassNames="fizz-margin-auto"
          /></td
        >
        {#if paymentsEnabled}
          <td
            ><Icon
              type="CancelCircle"
              height="16"
              width="16"
              color="#E1434F"
              extraClassNames="fizz-margin-auto"
            /></td
          >
        {/if}
      </tr>
    </tbody>
    {#if paymentsEnabled}
      <tbody>
        <tr>
          <td><strong>Payments</strong></td>
          <td />
          <td />
          <td />
          <td />
        </tr>
        <tr>
          <td>View Invoices</td>
          <td
            ><Icon
              type="CheckCircle"
              height="16"
              width="16"
              color="#36B37E"
              extraClassNames="fizz-margin-auto"
            /></td
          >
          <td
            ><Icon
              type="CheckCircle"
              height="16"
              width="16"
              color="#36B37E"
              extraClassNames="fizz-margin-auto"
            /></td
          >
          <td
            ><Icon
              type="CheckCircle"
              height="16"
              width="16"
              color="#36B37E"
              extraClassNames="fizz-margin-auto"
            /></td
          >
          <td
            ><Icon
              type="CheckCircle"
              height="16"
              width="16"
              color="#36B37E"
              extraClassNames="fizz-margin-auto"
            /></td
          >
        </tr>
        <tr>
          <td>Pay Invoices</td>
          <td
            ><Icon
              type="CheckCircle"
              height="16"
              width="16"
              color="#36B37E"
              extraClassNames="fizz-margin-auto"
            /></td
          >
          <td
            ><Icon
              type="CancelCircle"
              height="16"
              width="16"
              color="#E1434F"
              extraClassNames="fizz-margin-auto"
            /></td
          >
          <td
            ><Icon
              type="CancelCircle"
              height="16"
              width="16"
              color="#E1434F"
              extraClassNames="fizz-margin-auto"
            /></td
          >
          <td
            ><Icon
              type="CheckCircle"
              height="16"
              width="16"
              color="#36B37E"
              extraClassNames="fizz-margin-auto"
            /></td
          >
        </tr>
        <tr>
          <td>Manage Payment Methods</td>
          <td
            ><Icon
              type="CheckCircle"
              height="16"
              width="16"
              color="#36B37E"
              extraClassNames="fizz-margin-auto"
            /></td
          >
          <td
            ><Icon
              type="CancelCircle"
              height="16"
              width="16"
              color="#E1434F"
              extraClassNames="fizz-margin-auto"
            /></td
          >
          <td
            ><Icon
              type="CancelCircle"
              height="16"
              width="16"
              color="#E1434F"
              extraClassNames="fizz-margin-auto"
            /></td
          >
          <td
            ><Icon
              type="CheckCircle"
              height="16"
              width="16"
              color="#36B37E"
              extraClassNames="fizz-margin-auto"
            /></td
          >
        </tr>
      </tbody>
    {/if}
  </table>
</FizzStyles>
